import { fileCall } from "@/apis/base";
import { useContentStore } from "@/dev/store/useContentStore";
import { $s } from "@/helpers/settings.js";

function getContent(key) {
  const contentStore = useContentStore();

  if (contentStore.contentMap[key]) {
    contentStore.addKeyFound(key, contentStore.contentMap[key]);
  } else {
    console.warn(`[Content] key "${key}" not found.`);
    contentStore.addKeyMissing(key);
  }

  return contentStore.contentMap[key] || "";
}

export function $c(key) {
  return getContent(key);
}

export function loadContent() {
  const instanceID = $s("INSTANCE_ID");
  const fromFile = true; //$s("INSTANCE_ID");

  if (fromFile) {
    return fileCall(`content.${instanceID}`);
  } else {
    console.warn(
      "Loading content from API is not implemented yet. Falling back to file loading."
    );
  }
}
